import * as tslib_1 from "tslib";
import { AbstractMethodError, AbstractionBase } from "@awayjs/core";
/**
 *
 * @class away.pool.GL_TextureBaseBase
 */
var GL_TextureBase = (function (_super) {
    tslib_1.__extends(GL_TextureBase, _super);
    function GL_TextureBase(texture, shader) {
        var _this = _super.call(this, texture, shader) || this;
        _this._texture = texture;
        _this._shader = shader;
        _this._stage = shader._stage;
        return _this;
    }
    /**
     *
     */
    GL_TextureBase.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._texture = null;
        this._shader = null;
        this._stage = null;
    };
    GL_TextureBase.prototype._getFragmentCode = function (targetReg, regCache, sharedReg, inputReg) {
        if (inputReg === void 0) { inputReg = null; }
        throw new AbstractMethodError();
    };
    GL_TextureBase.prototype._setRenderState = function (renderable) {
        //overidden for state logic
    };
    GL_TextureBase.prototype.activate = function () {
        //overridden for activation logic
    };
    GL_TextureBase.prototype.getTextureReg = function (imageIndex, regCache, sharedReg) {
        var index = this._shader.imageIndices.indexOf(imageIndex); //todo: collapse the index based on duplicate image objects to save registrations
        if (index == -1) {
            var textureReg = regCache.getFreeTextureReg();
            sharedReg.textures.push(textureReg);
            this._shader.imageIndices.push(imageIndex);
            return textureReg;
        }
        return sharedReg.textures[index];
    };
    return GL_TextureBase;
}(AbstractionBase));
export { GL_TextureBase };



// WEBPACK FOOTER //
// ../dist/lib/textures/GL_TextureBase.js